import angular from 'angular';
import '../../shared.module';
import template from './choice-cards.component.html';
import './choice-cards.component.scss';
import { toggleItem } from '../../../core/helpers/array.helper';

export const CHOICE_TYPES = ['multiple', 'single', 'boolean'];
export const CHOICE_FORMATS = ['list', 'map'];

let sequence = 0;

function isEmptyChoice(type, format, value) {
  if (type === 'boolean') return value !== true;
  if (type === 'single') return value === undefined || value === null || value === '';
  if (format === 'map') return !value || !Object.keys(value).some((key) => value[key]);
  return !Array.isArray(value) || !value.length;
}

class ChoiceCardsController {
  constructor() {
    sequence += 1;
    this.name = `cp-choice-${sequence}`;
  }

  $onInit() {
    this.type = CHOICE_TYPES.includes(this.type) ? this.type : 'multiple';
    this.format = CHOICE_FORMATS.includes(this.format) ? this.format : 'list';
    this.valueKey = this.valueKey || 'value';
    this.labelKey = this.labelKey || 'label';
    this.descriptionKey = this.descriptionKey || 'description';
    this.ngModel.$isEmpty = (value) => isEmptyChoice(this.type, this.format, value);
  }

  get model() {
    return this.ngModel.$viewValue;
  }

  valueOf(option) {
    return angular.isObject(option) ? option[this.valueKey] : option;
  }

  labelOf(option) {
    return angular.isObject(option) ? option[this.labelKey] : option;
  }

  descriptionOf(option) {
    return angular.isObject(option) ? option[this.descriptionKey] : null;
  }

  iconOf(option) {
    return this.iconKey && angular.isObject(option) ? option[this.iconKey] : null;
  }

  isSelected(option) {
    if (this.type === 'boolean') return this.model === true;
    const value = this.valueOf(option);
    if (this.type === 'single') return this.model === value;
    if (this.format === 'map') return Boolean(this.model && this.model[value]);
    return Array.isArray(this.model) && this.model.includes(value);
  }

  isDisabled(option) {
    return Boolean(this.disabled || (angular.isObject(option) && option.disabled));
  }

  choose(option) {
    if (this.isDisabled(option)) return;
    this.ngModel.$setViewValue(this.nextValue(option));
    this.ngModel.$setTouched();
  }

  nextValue(option) {
    if (this.type === 'boolean') return this.model !== true;
    const value = this.valueOf(option);
    if (this.type === 'single') return value;
    if (this.format === 'map') return { ...(this.model || {}), [value]: !this.isSelected(option) };
    return toggleItem(Array.isArray(this.model) ? this.model : [], value);
  }
}

ChoiceCardsController.$inject = ['$element'];

angular.module('app.shared').component('cpChoiceCards', {
  require: { ngModel: 'ngModel' },
  bindings: {
    options: '&',
    type: '@',
    format: '@',
    layout: '@',
    label: '@',
    description: '@',
    valueKey: '@',
    labelKey: '@',
    descriptionKey: '@',
    iconKey: '@',
    disabled: '<'
  },
  controller: ChoiceCardsController,
  controllerAs: 'vm',
  transclude: true,
  template
});
